import { faker } from '@faker-js/faker';
import { mockPaginate } from './paginate';
import { CohortType } from '@dynamika-shared/types/cohorts';

export function createRandomCohort(): CohortType {
  return {
    id: faker.string.uuid(),
    name: `Cohort ${faker.string.numeric(1)}`,
    numberOfPatients: faker.number.int(),
    patientCodePattern: faker.string.alphanumeric(),
    unscheduledAllowed: faker.datatype.boolean(),
    fetchPatientGender: faker.datatype.boolean(),
    status: 'ACTIVE',
    visits: [
      {
        daysFromBaseline: 30,
        id: 'b89f14b3-0d1a-4e0b-9e6f-849d6b3a0a18',
        labels: [
          '49fd02fb-6c0d-4d93-b72d-90707efb530f',
          'c4d76cb4-9b58-4b24-9c03-12a77c7f8e24',
        ],
        name: 'Visit 1',
        questionnaires: [],
      },
      {
        daysFromBaseline: 1,
        id: 'b89f14b3-0d1a-4e0b-9e6f-849d6b3a0a19',
        labels: [
          '49fd02fb-6c0d-4d93-b72d-90707efb530e',
          'c4d76cb4-9b58-4b24-9c03-12a77c7f8e25',
        ],
        name: 'Visit 2',
        questionnaires: [],
      },
    ],
  };
}

export function createRandomCohortList(count: number): CohortType[] {
  return faker.helpers.multiple(createRandomCohort, { count });
}

export function createPaginatedRandomClinicalTrialsList(
  count: number,
  args = { page: 1, size: 10 }
) {
  const cohorts = createRandomCohortList(count);
  return mockPaginate(cohorts, args);
}
